<template>
  <div class="fullPage" ref="fullPage">
    <div class="nav_box">
      <Nav :isClass="isClass"></Nav>
    </div>
    <div class="fullPageContainer" ref="fullPageContainer" @mousewheel="mouseWheelHandle"
      @DOMMouseScroll="mouseWheelHandle">
      <div class="section section1">
        <!-- <div class="st" @click="st">开始</div>  -->
        <div class="one_page">
          <div class="conter_box">
            <div class="top_title" :class="animationPage" id="top_title">
              <img src="../assets/img/border.png">
              <span>浙中公共算力调度枢纽</span>
              <img src="../assets/img/border.png">
            </div>
            <div class="content_title" :class="animationPage1">
              一站式算力交易和服务平台
            </div>
            <div class="content_foot" :class="animationPage2">
              实现对通用算力、超算算力、人工智能算力的统一管理、统一服务和统一运营
            </div>
          </div>
        </div>
      </div>
      <div class="section section2">
        <div class="section2_title" v-if="animationPage3">核心能力</div>
        <div class="section2_list" :class="animationPage3" v-if="animationPage3">
          <div class="section2_item " v-for="(item, index) in section2List" :key="index">
            <img :src="item.url">
            <div>{{ item.txt }}</div>
          </div>

        </div>
      </div>
      <div class="section section3">
        <div class="title_box" v-if="animationPage4">
          <div class="title_box1">总体能力</div>
          <div class="title_box2">Overall Ability</div>
        </div>
        <div class="section3_list" :class="animationPage4" v-if="animationPage4">
          <div class="section3_item" v-for="(item, index) in section3List" :key="index">
            <img :src="item.url">
            <div><span class="section3_item_title">{{ item.txt }}</span><span class="section3_item_num">{{ item.num
                }}</span></div>
          </div>
        </div>
        <div class="map_box">
          <Map></Map>
        </div>
      </div>
      <div class="section section4">
        <div class="section4_box">
          <div class="title_box1">行业应用</div>
          <div class="title_box2">Overall Ability</div>
        </div>
        <div class="grid_box">
          <div class="grid_left">
            <div class="grid_item img1">
              <div class="grid_item_title">工业仿真</div>
              <img src="../assets/img/位图@2x (1).png">
            </div>
            <div class="grid_item_line">
              <div class="grid_item img2">
                <div class="grid_item_title">IC设计</div>
                <img src="../assets/img/位图@2x(3).png">
              </div>
              <div class="grid_item img2">
                <div class="grid_item_title">生物基因</div>
                <img src="../assets/img/位图@2x(1).png">
              </div>
            </div>
            <div class="grid_item_line">
              <div class="grid_item img2">
                <div class="grid_item_title">气象环境</div>
                <img src="../assets/img/位图@2x(4).png">
              </div>
              <div class="grid_item img2">
                <div class="grid_item_title">地质勘探</div>
                <img src="../assets/img/位图@2x(2).png">
              </div>
            </div>
          </div>
          <div class="grid_right">
            <div class="right_top">
              <div class="grid_item img3">
                <div class="grid_item_title">自动驾驶</div>
                <img src="../assets/img/位图@2x(5).png">
              </div>
              <div class="right_top_right">
                <div class="grid_item img4">
                  <div class="grid_item_title">空天遥感</div>
                  <img src="../assets/img/位图@2x(6).png">
                </div>
                <div class="grid_item img4">
                  <div class="grid_item_title">智能语音</div>
                  <img src="../assets/img/位图@2x(7).png">
                </div>
              </div>
            </div>
            <div class="grid_item img5">
              <div class="grid_item_title">动漫渲染</div>
              <img src="../assets/img/位图@2x.png">
            </div>
          </div>
        </div>
      </div>
      <div class="section section5">
        <div class="section5_box">
          <div class="title_box1">已接入算力中心</div>
          <!-- <div class="title_box2">Partner</div> -->
        </div>
        <div class="section5_list" :class="animationPage5" v-if="animationPage5">
          <div class="section5_item" v-for="(item, index) in section5List" :key="index">
            <img :src="item.url" :style="{ width: item.width + 'px', height: item.height + 'px' }">
            <!-- <div class="section5_item_phone">联系方式：{{ item.phone }}</div> -->
          </div>
        </div>
      </div>
      <div class="section_fort section6">
        <div class="fort_box">
          <div class="foot_title">共建科技算力服务生态</div>
          <div class="foot_btn">立即咨询</div>
        </div>
      </div>
    </div>
    <!-- <div class="footer_fout">
      <Clas></Clas>
    </div> -->
  </div>
</template>
<script>
import { gsap } from 'gsap'
import Nav from "../components/nav.vue";
import Map from "../components/map.vue";
import Clas from "../components/clas.vue";
export default {
  name: "Home",
  components: {
    Nav,
    Map,
    Clas
  },
  data() {
    return {
      animationPage: '',
      animationPage1: '',
      animationPage2: '',
      animationPage3: '',
      animationPage4: '',
      animationPage5: '',
      fullpage: {
        current: 1, // 当前的页面编号
        isScrolling: false, // 是否在滚动,是为了防止滚动多页，需要通过一个变量来控制是否滚动
        deltaY: 0, // 返回鼠标滚轮的垂直滚动量，保存的鼠标滚动事件的deleteY,用来判断是往下还是往上滚
        totalHeight: 0,

      },
      isClass: false,
      section2List: [{
        url: require('../assets/img/bg3_1.png'),
        txt: '广泛的供需链接和算力市场化交易驱动的泛在算力资源优化配置'
      }, {
        url: require('../assets/img/bg3_2.png'),
        txt: 'HPC、AI、云原生与多云服务算力运营平台软件与全栈技术工具'
      }, {
        url: require('../assets/img/bg3_3.png'),
        txt: '面向科技和产业多种应用场景的解决方案、交付运维与技术支持'
      }, {
        url: require('../assets/img/bg3_4.png'),
        txt: '高通量低成本的共享科技算力网络通信基础设施运营与通信服务'
      }],
      section3List: [{
        url: require('../assets/img/bg4_3.png'),
        txt: '聚合超级算力PFlops',
        num: '1,020+'
      }, {
        url: require('../assets/img/bg4_4.png'),
        txt: '链接通用算力核心',
        num: '1500+'
      }, {
        url: require('../assets/img/bg4_5.png'),
        txt: '融合多元算力芯片',
        num: '8+'
      }, {
        url: require('../assets/img/bg4_6.png'),
        txt: '接入算力资源中心',
        num: '20+'
      }, {
        url: require('../assets/img/bg4_7.png'),
        txt: '时延ms',
        num: '市内1-省内3-长三角5'
      }],
      section5List: [
        {
          url: require('../assets/img/home-image.png'),
          width: 357,
          height: 268,
          phone: '15305799692'
        },
        {
          url: require('../assets/img/home-image2.png'),
          width: 416,
          height: 123,
          phone: '15657171815'
        },
        {
          url: require('../assets/img/home-image3.png'),
          width: 515,
          height: 386,
          phone: '13957990939'
        },
      ],
      // section5List: [
      //   {
      //     url: require('../assets/img/位图@2x(7)(1).png'),
      //     width: 240,
      //     height: 70,
      //     phone:'15305799692'
      //   }, {
      //     url: require('../assets/img/位图@2x(8)(1).png'),
      //     width: 240,
      //     height: 70
      //   }, {
      //     url: require('../assets/img/位图@2x(9).png'),
      //     width: 240,
      //     height: 70
      //   }, {
      //     url: require('../assets/img/位图@2x(12).png'),
      //     width: 114,
      //     height: 48
      //   }, {
      //     url: require('../assets/img/位图@2x(10).png'),
      //     width: 177,
      //     height: 39
      //   }, {
      //     url: require('../assets/img/位图@2x(11).png'),
      //     width: 166,
      //     height: 61
      //   }, {
      //     url: require('../assets/img/位图@2x(3)(1).png'),
      //     width: 235,
      //     height: 90
      //   }, {
      //     url: require('../assets/img/位图@2x(5)(1).png'),
      //     width: 141,
      //     height: 90
      //   }, {
      //     url: require('../assets/img/位图@2x(6)(1).png'),
      //     width: 210,
      //     height: 59
      //   }, {
      //     url: require('../assets/img/位图@2x(2)(1).png'),
      //     width: 176,
      //     height: 56
      //   }, {
      //     url: require('../assets/img/位图@2x(13).png'),
      //     width: 184,
      //     height: 43
      //   }, {
      //     url: require('../assets/img/位图@2x(14).png'),
      //     width: 166,
      //     height: 22
      //   }, {
      //     url: require('../assets/img/位图@2x(8).png'),
      //     width: 90,
      //     height: 90
      //   }, {
      //     url: require('../assets/img/位图@2x(1)(1).png'),
      //     width: 200,
      //     height: 75
      //   }, {
      //     url: require('../assets/img/位图@2x(4)(1).png'),
      //     width: 240,
      //     height: 90
      //   }
      // ]

    };
  },
  mounted() {
    let minWidth = window.screen.width;
    this.$refs["fullPage"].style.minWidth = minWidth + "px";
    this.animationPage = 'animation'
    this.animationPage1 = 'animation1'
    this.animationPage2 = 'animation2'

  },
  methods: {
    // 第一页动画
    getPage1() {
      this.animationPage = ''
      this.animationPage1 = ''
      this.animationPage2 = ''
      setTimeout(() => {
        this.animationPage = 'animation'
        this.animationPage1 = 'animation1'
        this.animationPage2 = 'animation2'
      }, 0);

      // gsap.to(".content_title", {
      //   duration: 1.5, // 动画时间
      //   x: -100, // x 轴
      //   y: 0, // y 轴
      //   opacity: 0.5,
      //   // 结束事件返转动画
      //   onComplete: function () {
      //     this.reversed(true);
      //   }
      // })
    },
    // 第二页动画
    getPage2() {
      this.animationPage3 = ''
      setTimeout(() => {
        this.animationPage3 = 'list_item'
      }, 500);
    },
    // 第三页动画
    getPage3() {
      this.animationPage4 = ''
      setTimeout(() => {
        this.animationPage4 = 'list_item_page3'
      }, 500);
    },
    // 第五页动画
    getPage5() {
      this.animationPage5 = ''
      setTimeout(() => {
        this.animationPage5 = 'list_item_page5'
      }, 500);
    },
    next() { // 往下切换
      let len = 6; // 页面的个数
      if (this.fullpage.current + 1 <= len) { // 如果当前页面编号+1 小于总个数，则可以执行向下滑动
        this.fullpage.current += 1; // 页面+1
        this.move(this.fullpage.current); // 执行切换
      }
    },
    pre() {// 往上切换
      if (this.fullpage.current - 1 > 0) { // 如果当前页面编号-1 大于0，则可以执行向下滑动
        this.fullpage.current -= 1;// 页面+1
        this.move(this.fullpage.current);// 执行切换
      }
    },
    move(index) {
      switch (index) {
        case 1:
          this.getPage1();
          this.isClass = false
          break;
        case 2:
          this.getPage2();
          break;
        case 3:
          this.getPage3();
          break;
        case 5:
          this.getPage5();
          break;
        default:
          break;
      }
      if (index > 1) {
        this.isClass = true
      }
      this.fullpage.isScrolling = true; // 为了防止滚动多页，需要通过一个变量来控制是否滚动
      this.directToMove(index); //执行滚动
      setTimeout(() => {  //这里的动画是1s执行完，使用setTimeout延迟1s后解锁
        this.fullpage.isScrolling = false;
      }, 800);
    },
    directToMove(index) {
      let height = this.$refs["fullPage"].clientHeight; //获取屏幕的宽度
      let scrollPage = this.$refs["fullPageContainer"]; // 获取执行tarnsform的元素
      let scrollHeight; // 计算滚动的告诉，是往上滚还往下滚
      // console.log(this.fullpage.current);
      if (index == 6) {
        scrollHeight = -(Number(this.totalHeight) + 193) + "px";
        scrollPage.style.transform = `translateY(${scrollHeight})`;
      } else {
        scrollHeight = -(index - 1) * height + "px";
        this.totalHeight = scrollHeight.replace(/[^0-9]/ig, '')
        scrollPage.style.transform = `translateY(${scrollHeight})`;
      }

      this.fullpage.current = index;
    },
    mouseWheelHandle(event) { // 监听鼠标监听
      // 添加冒泡阻止
      let evt = event || window.event;
      if (evt.stopPropagation) {
        evt.stopPropagation();
      } else {
        evt.returnValue = false;
      }
      if (this.fullpage.isScrolling) { // 判断是否可以滚动
        return false;
      }
      let e = event.originalEvent || event;
      this.fullpage.deltaY = e.deltaY || e.detail; // Firefox使用detail
      if (this.fullpage.deltaY > 0) {
        this.next();
      } else if (this.fullpage.deltaY < 0) {
        this.pre();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.nav_box {
  position: absolute;
  top: 0;
  z-index: 99;
  width: 100%;
}

.fullPage {
  height: 100vh;
  overflow: hidden;
  position: relative;
  /* background-color: rgb(189, 211, 186); */
}

.fullPageContainer {
  width: 100%;
  height: 100vh;
  transition: all linear 0.5s;
}

.section {
  width: 100%;
  height: 100vh;
  background-position: center center;
  background-repeat: no-repeat;
}

.section_fort {
  width: 100%;
  height: 195px;
  background-position: center center;
  background-repeat: no-repeat;
}

.section1 {
  background-image: url("../assets/img/bg1.png");
  background-repeat: no-repeat;
  background-size: 100%, auto;
  background-position: center top;
}

.section1 .secction1-content {
  color: #fff;
  text-align: center;
  position: absolute;
  top: 40%;
  right: 0;
  left: 0;
}

.secction1-content h1 {
  font-size: 40px;
  padding-bottom: 30px;
}

.secction1-content p {
  font-size: 20px;
}

.section2 {
  background-color: #F9F9FA;
  height: 100%;
  background-image: url("../assets/img/bg2_left.png"), url("../assets/img/bg2_right.png");
  background-repeat: no-repeat;
  background-size: 576px 458px, 673px 535px;
  background-position: left top, right bottom;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .section2_title {
    width: 100%;
    text-align: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 20px;
    color: #333333;
    line-height: 28px;
    margin-bottom: 60px;
    animation: sectitle 1s;
  }

  @keyframes sectitle {
    0% {
      scale: .2;
      opacity: .5;
    }

    100% {
      scale: 1;
      opacity: 1;

    }
  }

  .section2_list {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .section2_item {
      margin-right: 48px;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: center;
      background: #FFFFFF;
      box-shadow: 0px 3px 51px 0px rgba(0, 0, 0, 0.03);
      border-radius: 6px;
      width: 284px;
      height: 365px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #333333;

      div {
        width: 170px;
        line-height: 25px;
        text-align: justify;
      }

      img {
        width: 70px;
        height: 70px;
      }

      &:hover {
        background: #094990;
        color: #fff;
        transition: all 200ms linear;
      }


    }
  }

  .list_item {

    .section2_item:nth-child(1) {
      animation: item1 1s;
    }

    .section2_item:nth-child(2) {
      animation: item1 1.5s;
    }

    .section2_item:nth-child(3) {
      animation: item1 2s;
    }

    .section2_item:nth-child(4) {
      animation: item1 2.5s;
    }

    @keyframes item1 {
      0% {
        opacity: 0;
        transform: translatey(100px);
      }

      100% {
        opacity: 1;

      }
    }
  }
}

.section3 {
  // background: linear-gradient( 90deg, #0A54AE 0%, #066FF2 100%);
  background-color: #066FF2;

  height: 100%;
  background-image: url("../assets/img/bg4_1.png"), url("../assets/img/bg4_2.png");
  background-repeat: no-repeat;
  background-size: 670px 100%, 895px 100%;
  background-position: left, right;
  position: relative;

  .map_box {
    position: absolute;
    bottom: 0;
    right: 0;
  }

  .title_box {
    position: absolute;
    left: 45%;
    top: 17%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .title_box1 {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #FFFFFF;
      margin-bottom: 12px;
    }

    .title_box2 {
      font-weight: 500;
      font-size: 20px;
      color: #FFFFFF;
    }

    & {
      animation: sectitle2 1s;
    }

    @keyframes sectitle2 {
      0% {
        scale: .2;
        opacity: .5;
      }

      100% {
        scale: 1;
        opacity: 1;

      }
    }
  }

  .section3_list {
    position: absolute;
    left: 10%;
    top: 30%;

    .section3_item {
      padding: 12px 20px;
      margin-bottom: 20px;
      width: 444px;
      height: 50px;
      background: linear-gradient(90deg, hsla(0, 0%, 100%, .7), rgba(191, 220, 253, .4) 37%, rgba(16, 124, 247, 0));
      display: flex;
      align-items: center;

      img {
        width: 45px;
        height: 45px;
      }
    }

    .section3_item_title {
      font-weight: 400;
      font-size: 14px;
      color: #FFFFFF;
    }

    .section3_item_num {
      font-weight: 500;
      font-size: 28px;
      color: #FFFFFF;
      margin-left: 4px;
    }
  }

  .list_item_page3 {

    .section3_item:nth-child(1) {
      animation: item2 .5s;
    }

    .section3_item:nth-child(2) {
      animation: item2 1s;
    }

    .section3_item:nth-child(3) {
      animation: item2 1.5s;
    }

    .section3_item:nth-child(4) {
      animation: item2 2s;
    }

    .section3_item:nth-child(5) {
      animation: item2 2.5s;
    }

    @keyframes item2 {
      0% {
        opacity: 0;
        transform: translatex(100px);
      }

      100% {
        opacity: 1;

      }
    }
  }
}

.section4 {
  background-color: #fff;
  overflow: hidden;

  .section4_box {
    width: 100%;
    text-align: center;

    .title_box1 {
      font-weight: 400;
      font-size: 20px;
      color: #333333;
    }

    .title_box2 {
      font-weight: 500;
      font-size: 14px;
      color: #999999;
      margin-top: 12px;
    }
  }

  .grid_box {
    margin-top: 20px;
    display: flex;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
      transition: all 1.5s;
    }

    .grid_item {
      position: relative;
      overflow: hidden;

      div {
        position: absolute;
        top: 20px;
        left: 20px;
        font-weight: 400;
        font-size: 18px;
        color: #FFFFFF;
        z-index: 99;
        transition: all 1.5s;
      }

      &:hover {
        div {
          font-size: 20px;
        }

        img {
          transform: scale(1.3);
        }

      }
    }

    .grid_left {
      display: flex;
      flex-direction: column;

      .grid_item_line {
        width: 593px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 17px;
      }

      .img1 {
        width: 593px;
        height: 230px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .img2 {
        width: 288px;
        height: 230px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .grid_right {
      margin-left: 17px;

      img {
        width: 100%;
        height: 100%;
      }

      .right_top {
        display: flex;
        justify-content: space-between;

        .right_top_right {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
      }

      .img3 {
        width: 288px;
        height: 477px;
      }

      .img4 {
        width: 288px;
        height: 230px;
      }

      .img5 {
        width: 592px;
        height: 230px;
        margin-top: 20px;
      }
    }
  }
}

.section5 {
  // background-color: rgb(125, 195, 134);
  background-image: url("../assets/img/bg5_1.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  .section5_box {
    position: absolute;
    left: 45%;
    top: 16%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .title_box1 {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 22px;
      color: #333333;
      margin-bottom: 12px;
    }

    .title_box2 {
      font-weight: 500;
      font-size: 14px;
      color: #999999;
    }
  }

  .section5_list {
    // background-color: #fff;
    width: 100%;
    display: flex;
    // flex-wrap: wrap;
    align-items: center;
    justify-content: space-around;

    .section5_item {
      width: 33%;
      height: 400px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;

      .section5_item_phone {
        display: flex;
        align-items: center;
        position: absolute;
        bottom: 22%;
        width: 322px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        font-size: 28px;
        color: #000000;
      }
    }

  }

  .list_item_page5 {
    overflow: hidden;
    animation: sectitle5 .5s;

    @keyframes sectitle5 {
      0% {
        height: 0px;
      }

      100% {
        height: 260px;

      }
    }
  }

}

.section6 {
  background-image: url("../assets/img/位图@2x(15).png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .fort_box {
    width: 1300px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .foot_title {
    font-weight: 500;
    font-size: 22px;
    color: #FFFFFF;
  }

  .foot_btn {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 124px;
    height: 40px;
    background: #FFFFFF;
    border-radius: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #094990;

    &:hover {
      background-color: #094990;
      color: #FFFFFF;
    }
  }

}

.one_page {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}



.top_title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;

  img {
    width: 410px;
    height: 2px;
  }

  span {
    font-weight: 400;
    font-size: 20px;
    color: #FFFFFF;
    letter-spacing: 10px;
    text-align: center;
    margin: 10px 0;
  }
}

.animation {
  animation: change 1.5s;
}

@keyframes change {
  0% {
    scale: .2;
    opacity: .5;
  }

  100% {
    scale: 1;
    opacity: 1;

  }
}



.content_title {
  font-weight: 500;
  font-size: 38px;
  color: #FFFFFF;
  line-height: 53px;
  text-align: center;
  margin: 18px 0;
}

.animation1 {
  animation: change1 1.5s;
}

@keyframes change1 {
  0% {
    transform: translatex(-1000px);
    opacity: .3;
  }

  100% {
    // transform: translatex(1000px);
    opacity: 1;

  }
}

.content_foot {
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
}

.animation2 {
  animation: change2 1.5s;
}

@keyframes change2 {
  0% {
    transform: translatex(1000px);
    opacity: .3;
  }

  100% {
    // transform: translatex(1000px);
    opacity: 1;

  }
}

.footer_fout {
  position: fixed;
  bottom: 10%;
  right: 0;
}

::-webkit-scrollbar {
  display: none;
}
</style>
